import { defineStore } from 'pinia'

export const usePreBasketStore = defineStore('preBasket', {
    state: () => ({
        productIdReferrer: null as number | null,
    }),
    actions: {
        setProductIdReferrer(productId: number) {
            this.productIdReferrer = productId
        },

        clearProductIdReferrer() {
            this.productIdReferrer = null
        },
    },
})
